<!-- The Masterclass program (Year/Masterclass.vue; 2026-10-28): every Masterclass of the year, in
     person, virtual and online, in one table, filtered by event like the Program page (Seán,
     2026-10-29: filters, no accordions). On the page under its heading; in the narrow sidebar's
     Program panel without one (its tab names it) -->
<template>
  <!-- two columns only: the page's own text above, the program below, set apart by a rule in the
       sidebar's dividers' colour (Seán, 2026-10-29) -->
  <hr v-if="heading" class="programRule" />
  <h4 v-if="heading" id="program">Program</h4>
  <ProgramTable :session="MASTERCLASS_SESSIONS" :description="false" :show-day-tags="true" />
</template>

<script setup>
import ProgramTable from "@/components/Program/Table.vue";
defineProps({heading: {type: Boolean, default: true}});

// the sheet's categories: "Masterclass", "Virtual Masterclass (A)", "Online Masterclass", …
const MASTERCLASS_SESSIONS = /^((virtual|online) )?masterclass\b(?! &)/i;
</script>

<style scoped>
h4 {
  display: inline;
  float: left;
}
.programRule {
  clear: both;
  margin: 24px 0 0; /* about as far below, to the heading's letters */
  border: 0;
  border-top: 1px solid var(--border-color-subtle);
}
/* the time zone menu (Program/TimeZone.vue, floated right) on the heading's line, from a little
   its text on the heading's baseline, as on the Program page (Seán, 2026-10-29) */
h4 + :deep(#timezone) {
  margin-top: 10px;
  position: relative;
  top: 8px;
}
</style>
